<!-- Tabs for ski, boots and so on-->
<ul class="nav equipment-tabs" id="equipment-tabs">
  @if (!shopCategories().length) {
    <li class="nav-item">
      <app-skeleton-loader [loaderWidth]="'240px'" [loaderHeight]="'47px'" />
    </li>
  }
  @defer (when shopCategories()) {
    @for (category of shopCategories(); track category) {
      <li class="nav-item">
        <div
          class="nav-link align-items-center"
          [class.active]="selectedCategory() === category"
          (click)="switchCategory(category)">
          @switch (category) {
            @case (1) {
              <app-icon name="ski" width="38px" height="38px" style="align-self: flex-end" />
            }
            @case (2) {
              <app-icon name="boots" width="38px" height="20px" />
            }
            @case (3) {
              <app-icon name="snowboard" width="38px" height="38px" style="align-self: flex-end" />
            }
            @case (4) {
              <app-icon name="funEquip" width="38px" height="20px" />
            }
            @case (5) {
              <app-icon name="nordic" width="38px" height="38px" style="align-self: flex-end" />
            }
            @case (6) {
              <app-icon name="helmet" width="38px" height="20px" />
            }
          }
          <span class="text">{{ 'ALPINPRODUCT.productCategory.' + category | alpitranslate }}</span>
        </div>
      </li>
    }
  }
</ul>
